export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const dashboardBackground = require("../assets/DarkBgImage.png");
export const lightBackground = require("../assets/LightBgImage.png");
export const RightIcon = require("../assets/RightIcon.svg");
export const googleImage=require('../assets/google.png')
